export default {
    error: false,
    loading: false,
    message_loading : 'Cargando Plantilla De Inventarios Ideales',
    file: ''
};



// WEBPACK FOOTER //
// ./src/modules/import-ideal-balances/state.js